import React, { useState, useEffect, useContext, useRef } from "react";
import { Row, Col, Image } from "react-bootstrap";
import TabsLucrare from "../tabs_lucrare/TabsLucrare";
import ModalComponent from "./basic/ModalComponent";
import Lucrare from "../lucrare/Lucrare";
import {
  getLucrariByTypeService,
  readLucrariService
} from "../backend/LucrareService";
import LucrareItem from "../lucrare/LucrareItem";
import { RefreshContext } from "../context/RefreshContext";
import logo_image from "../imgs/logo.png";
import { refreshTimer, readLucrariTimer } from "../utils/Values";
import DomainHeader from "./DomainHeader";

const Interfoane = () => {
  const [showModal, setShowModal] = useState(false);
  const [lucrari, setLucrari] = useState([]);
  const [triggerLucrari, setTriggerLucrari] = useState(false);
  const [currentLucrare, setCurrentLucrare] = useState();
  const [activeTab, setActiveTab] = useState("locatie");
  const [refresh, setRefresh] = useState(false);
  const { internet, serverError, refreshNumere } = useContext(RefreshContext);
  const isReadLucrari = useRef(false);

  const setTab = value => {
    setActiveTab(value);
  };

  const refreshLucrari = () => {
    setTriggerLucrari(!triggerLucrari);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const getLucrari = async () => {
    try {
      const result = await getLucrariByTypeService("interfoane");
      setLucrari(result);
      if (result.some(item => !item.isRead) == false) {
        isReadLucrari.current = true;
      } else {
        isReadLucrari.current = false;
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const id = startRefreshTimer();
    return () => {
      clearInterval(id);
    };
  }, [refresh]);

  const startRefreshTimer = () => {
    return setInterval(() => {
      setRefresh(!refresh);
    }, refreshTimer);
  };

  useEffect(() => {
    getLucrari();
  }, [triggerLucrari, refresh]);

  const readLucrari = async () => {
    try {
      if (!isReadLucrari.current) {
        await readLucrariService("interfoane");
        refreshLucrari();
        refreshNumere();
        isReadLucrari.current = true;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const markLucrariRead = timeOut => {
    return setTimeout(() => {
      readLucrari();
    }, timeOut);
  };

  useEffect(() => {
    const id = markLucrariRead(readLucrariTimer);
    return () => {
      clearInterval(id);
      readLucrari();
    };
  }, []);

  return (
    <Row>
      <Col md={9}>
        {internet && !serverError ? (
          <>
            <Row className={"mb-3"}>
              <DomainHeader
                domeniuName={"Interfoane"}
                domeniuClassName={"interfoane_header"}
                setShowModalCallback={setShowModal}
              />
            </Row>
            <Row className="middleScreen" onClick={readLucrari}>
              <Col>
                {lucrari.map((lucrare) => (
                  <LucrareItem
                    key={lucrare.uid}
                    refreshLucrari={refreshLucrari}
                    lucrare={lucrare}
                    currentLucrare={currentLucrare}
                    setCurrentLucrare={setCurrentLucrare}
                    setTab={setTab}
                  />
                ))}
              </Col>
            </Row>
            <ModalComponent
              show={showModal}
              close={closeModal}
              headingText="Lucrare Interfoane"
              body={
                <Lucrare
                  closeModal={closeModal}
                  locationType="interfoane"
                  refreshLucrari={refreshLucrari}
                />
              }
            />
          </>
        ) : (
          <div className="no_internet_wrapper">
            <Image src={logo_image} />
            <div className="no_internet_text">
              {serverError
                ? `Nu este conexiune la server`
                : `Nu este conexiune la internet`}
            </div>
          </div>
        )}
      </Col>
      <Col
        md={3}
        className="lineRightDashboard"
        style={{ marginRight: "0px", paddingRight: "0px" }}
      >
        <TabsLucrare
          locationType="interfoane"
          currentLucrare={currentLucrare}
          setCurrentLucrare={setCurrentLucrare}
          activeTab={activeTab}
          setTab={setTab}
          refreshLucrari={refreshLucrari}
        />
      </Col>
    </Row>
  );
};

export default Interfoane;
